import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

import nl from 'vuetify/lib/locale/nl';

export default new Vuetify({
  lang: {
        locales: { nl },
            current: 'nl',
  },
});
